import React, { useState } from 'react';
import Header from '@/components/layout/Header';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import Layout from '@/components/layout/Layout';
import { LayoutDashboard, ZoomIn } from 'lucide-react';
import AnalyticsVisualizations from '@/components/analytics/AnalyticsVisualizations';
import { getDummyUserProfile } from '@/pages/Profile';
import { TooltipProvider } from '@/components/ui/tooltip';

const Analytics: React.FC = () => {
  const [timeRange, setTimeRange] = useState('month');
  const userProfile = getDummyUserProfile();
  
  return (
    <Layout>
      <TooltipProvider>
        <div className="pt-6 px-4 max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
            <div className="space-y-1">
              <h1 className="text-3xl font-bold">Analytics & Insights</h1>
              <p className="text-muted-foreground">Track your performance and growth across platforms</p>
            </div>
            
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
              <Tabs defaultValue="overview" className="w-fit">
                <TabsList>
                  <TabsTrigger value="overview" className="gap-1">
                    <LayoutDashboard className="h-4 w-4" />
                    <span className="hidden sm:inline">Overview</span>
                  </TabsTrigger>
                  <TabsTrigger value="detailed" className="gap-1">
                    <ZoomIn className="h-4 w-4" />
                    <span className="hidden sm:inline">Detailed</span>
                  </TabsTrigger>
                </TabsList>
              </Tabs>
              
              <Tabs defaultValue={timeRange} onValueChange={setTimeRange} className="w-fit">
                <TabsList>
                  <TabsTrigger value="week">Week</TabsTrigger>
                  <TabsTrigger value="month">Month</TabsTrigger>
                  <TabsTrigger value="year">Year</TabsTrigger>
                  <TabsTrigger value="all">All Time</TabsTrigger>
                </TabsList>
              </Tabs>
            </div>
          </div>
          
          <Tabs defaultValue="overview">
            <TabsContent value="overview" className="mt-0">
              <AnalyticsVisualizations timeRange={timeRange} userProfile={userProfile} />
            </TabsContent>
            
            <TabsContent value="detailed" className="mt-0">
              <div className="p-8 text-center border border-border rounded-lg">
                <ZoomIn className="h-16 w-16 mx-auto mb-4 text-muted-foreground/30" />
                <h3 className="text-xl font-semibold mb-2">Detailed Analytics</h3>
                <p className="text-muted-foreground max-w-md mx-auto mb-4">
                  Access in-depth analytics with custom date ranges, advanced filtering, and exportable reports.
                </p>
                <div className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-soundcharts-purple/20 text-soundcharts-purple rounded-full text-sm">
                  <span>Coming Soon</span>
                </div>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </TooltipProvider>
    </Layout>
  );
};

export default Analytics;
